import { Box } from "@mui/material";
import { AdminConsoleHeader } from "./AdminConsoleHeader";

interface ITemplateDefaultAdminConsole {
    iconTitle: React.ReactNode;
    title: string;
    subtitle: string;
    children: React.ReactNode;
}

export const TemplateDefaultAdminConsole: React.FC<ITemplateDefaultAdminConsole> = ({
    iconTitle,
    title,
    subtitle,
    children
}) => {

    return (
        <>
            <Box sx={{
                padding: '15px 30px',
                backgroundColor: '#F7F8FA',
                height:'calc(100vh - 66px)',
                display: 'flex',
                flexDirection: 'column',
            }}>

                <Box sx={{
                    background: '#FFFFFF 0% 0% no-repeat padding-box',
                    border: '1px solid #0000001A',
                    borderRadius: '4px',
                    padding: '30px',
                    height: '100%',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: '20px',
                        height: '100%',
                    }}>
                        <AdminConsoleHeader
                            iconTitle={iconTitle}
                            title={title}
                            subtitle={subtitle} />
                        <Box sx={{ 
                            flex: 1,
                            overflowY: 'auto',
                            minHeight: 0,
                            }} >
                            {children}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
};